import React from 'react';
import APopup from 'antd-mobile/lib/popup';



export default class Popup extends APopup {}